import React, { Component } from "react"
import "./PipetteRack.scss";

import PipetteRackImg from "./img/PipetteRack.svg"

import { withTranslation } from 'react-i18next'

class PipetteRack extends Component {
    render() {
        return (
          <ul>
            <li
                id={"PipetteRack_"+this.props.id}
                className="PipetteRack dropTarget">
                <p aria-hidden="true" className="label" style={{display:"none"}}>{this.props.t("Pipette rack")}</p>
                <img src={PipetteRackImg} aria-label={this.props.t('Laboratory micropipette rack')} />
            </li>
          </ul>
        )
    }
}
export default withTranslation()(PipetteRack);
